<div class="animated fadeInRight">
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    modulo="Promociones" [tituloCard]="tituloCard" titulo='Promociones / {{condicion}}'>
  </app-lfsa-card-v2>
</div>

<!-- INICIO BOTONES-->
<ng-template #innTemplateButton>
  <div class="col-md-6 text-end mb-2">
      <button class="btn btn-outline-danger me-2" routerLink=".."><i class="fas fa-arrow-left"></i></button>
      <button class="btn btn-outline-success" (click)="nuevaCondicion()">
        <i aria-hidden="true" class="fa fa-plus"></i>Agregar Nueva condición
      </button>
  </div>
</ng-template>
<!-- END BOTONES -->

<!-- INICIO DE GRID-->
<ng-template #enviarTemplateEdit>
  <ag-grid-angular #agGridBonificadores (gridReady)="onGridReady($event)" class="ag-theme-alpine"
    [columnDefs]="columnDefs" 
    [frameworkComponents]="frameworkComponents"
    id="myGridListCondicionesTier" 
    [ngStyle]="{width: '100%', height: '400px'}" 
    [paginationPageSize]="15"
    [pagination]="true" 
    [rowData]="listGetAllCondicion">
  </ag-grid-angular>
</ng-template>
<!-- END GRID-->

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-md'" [titulo]="tituloModal" [innTemplate]="abrirModal" 
                [idButton]="'abrirModal'" [idClose]="'cerrarModal'">
</app-lfsa-modal>

<ng-template #abrirModal>
  <!-- CONDICION POR TIER-->
  <app-promo-cond-tier-form *ngIf="condicion == 'tiers'"
    [idPromo]="idPromo"
    [idCondicionInput]="idCondicion"
    (back)="back()"
    (create)="guardarNuevaCondicion($event)">
  </app-promo-cond-tier-form>
  <!-- CONDICION POR TIER *ngIf="verFormAddCondicion" -->

  <!-- T.20331 Essential: nuevas cond. para promos -->
  <app-promo-agrupacion-tarifa *ngIf="condicion == 'agrupacionTarifa'"
    [idPromo]="idPromo" [idCondicionInput]="idCondicion"
    (back)="back()" (create)="guardarNuevaCondicion($event)"
    (listGrid)="recibeColumnasGrid($event)">
  </app-promo-agrupacion-tarifa>

  <app-promo-canal-vendedor-form *ngIf="condicion == 'canalVendedor'"
    [idPromo]="idPromo" [idCondicionInput]="idCondicion"
    (back)="back()" (create)="guardarNuevaCondicion($event)"
    (listGrid)="recibeColumnasGrid($event)">
  </app-promo-canal-vendedor-form>
  <!-- T.20331 -->

</ng-template>
<!-- END MODAL -->
